import React, { useEffect } from "react";
import { Form, Input, Button, DatePicker } from "antd";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import dayjs from "dayjs"; // ✅ IMPORTANT

const UpdateNotice = () => {
  const [form] = Form.useForm();
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`https://rhrmapi.up2dateinc.com/api/notices/${id}`)
      .then(res => {
        const data = res.data;

        form.setFieldsValue({
          type: data.type,
          description: data.description,
          date: data.date ? dayjs(data.date) : null, // ✅ FIX
          by: data.by,
        });
      });
  }, [id, form]);

  const onFinish = async (values) => {
    try {
      const payload = {
        ...values,
        date: values.date ? values.date.format("YYYY-MM-DD") : null, // ✅ convert back
      };

      await axios.put(`https://rhrmapi.up2dateinc.com/api/notices/${id}`, payload);

      navigate("/admin/manage-notice");
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Form form={form} onFinish={onFinish} layout="vertical">
      
      <Form.Item name="type" label="Notice Type" rules={[{ required: true }]}>
        <Input />
      </Form.Item>

      <Form.Item name="description" label="Description" rules={[{ required: true }]}>
        <Input.TextArea />
      </Form.Item>

      <Form.Item name="date" label="Notice Date" rules={[{ required: true }]}>
        <DatePicker style={{ width: "100%" }} />
      </Form.Item>

      <Form.Item name="by" label="Notice By" rules={[{ required: true }]}>
        <Input />
      </Form.Item>

      <Button type="primary" htmlType="submit">
        Update
      </Button>
    </Form>
  );
};

export default UpdateNotice;